import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, MessageCircle } from 'lucide-react';

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 flex items-center justify-center p-6">
      <div className="max-w-lg w-full">
        {/* Cancel Card */}
        <div className="bg-slate-800/50 backdrop-blur border border-slate-700 rounded-2xl p-8 text-center">
          {/* Cancel Icon */}
          <div className="w-20 h-20 bg-gradient-to-br from-slate-500 to-slate-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-white" />
          </div>

          <h1 className="text-3xl font-bold text-white mb-2">
            Checkout Cancelled
          </h1>
          
          <p className="text-slate-400 mb-8">
            No worries! Your subscription was not processed. You can try again anytime or contact us if you have questions.
          </p>

          {/* Helpful Tips */}
          <div className="bg-slate-900/50 rounded-xl p-4 mb-8 text-left">
            <p className="text-slate-300 text-sm mb-3 font-medium">Not sure which plan to choose?</p>
            <ul className="text-slate-400 text-sm space-y-2">
              <li>• Start with the <strong className="text-white">Starter Bundle</strong> for essential features</li>
              <li>• Try individual modules to build your custom stack</li>
              <li>• Contact sales for enterprise pricing</li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={() => navigate('/pricing')}
              className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white py-3 px-6 rounded-lg font-semibold flex items-center justify-center gap-2 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              Back to Pricing
            </button>
            
            <a
              href="mailto:sales@europacific.com?subject=Subscription Inquiry"
              className="w-full bg-slate-700 hover:bg-slate-600 text-white py-3 px-6 rounded-lg font-medium transition-all flex items-center justify-center gap-2"
            >
              <MessageCircle className="w-5 h-5" />
              Contact Sales
            </a>
          </div>
        </div>

        {/* Help Text */}
        <p className="text-slate-500 text-sm text-center mt-6">
          Questions? Email us at{' '}
          <a href="mailto:support@europacific.com" className="text-blue-400 hover:underline">
            support@europacific.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage;
